<template>
  <div class="card mt-4">
    <div class="table-responsive">
      <div class="table-controls m-3 d-flex">
        <div class="controls-wrap d-flex align-items-center">
          <!-- Integration Field -->
          <Search class="mr-3" placeholderText="Search (name)" @search="doSearch" />
          <div class="mr-3 ml-auto">
            <v-select
              style="min-width: 350px"
              v-model="listOfSelectedEmployers"
              @input="toggle"
              :options="getEmployersDropdown"
              placeholder="All Employers"
              inputId="employer-select"
              label="name"
              multiple
              :reduce="employer => employer.id"
              :clearable="true"
            >
              <template #option="{ name }"> {{ name }}</template></v-select
            >
          </div>
          <div
            v-show="!isPreviouslySubmited"
            class="published text-center"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Include pending and reviewed tests"
            @click="
              isPreviouslySubmited = !isPreviouslySubmited;
              toggle($event);
            "
          >
            <svgHelper name="test"></svgHelper>
          </div>

          <div
            class="published text-center active"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Exclude pending and reviewed tests"
            @click="
              isPreviouslySubmited = !isPreviouslySubmited;
              toggle($event);
            "
            v-show="isPreviouslySubmited"
          >
            <svgHelper name="test"></svgHelper>
          </div>
        </div>
      </div>

      <table class="table table-striped custom-table desktop-only-table">
        <thead class="bg-dark">
          <tr>
            <th nowrap scope="col">Name</th>
            <th nowrap scope="col">Position</th>
            <th nowrap scope="col">Employer</th>
            <th nowrap scope="col">Test</th>
            <th nowrap scope="col">Status</th>
            <th nowrap scope="col">Sent</th>
            <th nowrap scope="col">Completed</th>
            <th nowrap scope="col">Score</th>
            <th nowrap scope="col">&nbsp;</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="freelancer in freelancers.data" :key="freelancer.devskiller_assessment_id">
            <td id="title" nowrap>
              <router-link
                :to="{ name: 'candidate_id', params: { candidate_id: freelancer.candidate_id } }"
              >
                {{ freelancer.candidate_name }}
              </router-link>
            </td>
            <td>
              <div class="truncate-item">
                <div slot="reference">
                  <router-link
                    :title="freelancer.job_name"
                    :to="{ name: 'job_uuid', params: { job_uuid: freelancer.job_id } }"
                  >
                    {{ freelancer.job_name }}
                  </router-link>
                </div>
              </div>
            </td>
            <td>
              <div class="truncate-item">
                <div slot="reference">
                  <router-link
                    :title="freelancer.employer_name"
                    :to="{
                      name: 'employer_id',
                      params: { employer_id: freelancer.employer_id },
                    }"
                  >
                    {{ freelancer.employer_name }}
                  </router-link>
                </div>
              </div>
            </td>
            <td>
              <popper
                trigger="hover"
                :options="{
                  placement: 'top',
                  modifiers: { offset: { offset: '0,10px' } },
                }"
              >
                <div class="popper">{{ `${freelancer.candidate_name} skills report` }}</div>
                <a slot="reference">
                  <div>
                    <i
                      style="color:red; font-size: 22px; cursor: pointer;"
                      @click="onOpenDocPreview(freelancer.pdf_report)"
                      class="fas fa-file-pdf"
                    ></i>
                  </div>
                </a>
              </popper>
            </td>
            <td>{{ freelancer.status }}</td>
            <td>
              {{
                freelancer.sent
                  | formatDate({
                    format: getUserProfile.format_date,
                    timezone: getUserProfile.timezone,
                    hasHourAndMinutes: false,
                  })
              }}
            </td>
            <td>
              {{
                freelancer.completed
                  | formatDate({
                    format: getUserProfile.format_date,
                    timezone: getUserProfile.timezone,
                    hasHourAndMinutes: false,
                  })
              }}
            </td>
            <td>
              {{ freelancer.score ? `${freelancer.score}%` : 'N/A' }}
            </td>

            <td id="actions" align="center">
              <div class="icon-wrapper d-flex justify-content-around">
                <div
                  class="mr-2"
                  data-toggle="modal"
                  data-target=".bd-send-btn"
                  @click="setFreelancer(freelancer)"
                >
                  <svgHelper
                    class="submit"
                    style="fill: #5bb75b; cursor: pointer;"
                    name="submitPipeline"
                  />
                </div>

                <div
                  class="mr-2"
                  data-toggle="modal"
                  :data-target="freelancer.status === 'Completed' ? '.bd-like-btn' : null"
                  @click="setFreelancer(freelancer)"
                >
                  <svgHelper
                    class="approve-btn"
                    style="fill: #28a745; cursor:pointer"
                    :name="freelancer.status === 'Shared' ? 'thumbsUpFill' : 'thumbsUp'"
                  />
                </div>
                <div
                  data-toggle="modal"
                  :data-target="
                    freelancer.status === 'Completed' || freelancer.status === 'Expired'
                      ? '.bd-dislike-btn'
                      : ''
                  "
                  @click="setFreelancer(freelancer)"
                >
                  <svgHelper
                    style="fill: #f02800; cursor:pointer"
                    :name="freelancer.status === 'Declined' ? 'thumbsDownFill' : 'thumbsDown'"
                  />
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <ErrorList v-show="freelancers.length === 0" class="no-data-message" name="noReviewTests" />
    </div>

    <Spinner :isLoading="isLoading" />

    <div class="d-flex ml-auto mt-auto bottom-controls">
      <div class="d-none d-sm-block" id="pagination">
        <!-- Pagination -->

        <Pagination
          :currentPage="currentPage"
          :totalPages="totalPages"
          @nextPage="nextPage"
          @prevPage="previousPage"
          @selectPageByNumber="setPageByNumber"
          @firstPage="setToFirstPage"
          @lastPage="setToLastPage"
          @keyup="keymonitor"
        />
      </div>
    </div>

    <!-- Modals -->

    <div
      class="modal fade bd-send-btn"
      tabindex="-1"
      role="dialog"
      aria-labelledby="mainModalLabel"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5>Send Test</h5>

            <button
              ref="closeSendTest"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>
              Please confirm that a new test should be sent to the candidate.
            </p>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button
              :disabled="isTestLoading"
              @click="updateStatus(setForEdit.devskiller_assessment_id, 'Sent')"
              type="button"
              class="btn btn-primary btn-custom"
            >
              Send
            </button>
            <button
              type="button"
              class="btn btn-secondary btn-custom"
              data-dismiss="modal"
              ref="closeApproveModal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade bd-like-btn"
      tabindex="-1"
      role="dialog"
      aria-labelledby="mainModalLabel"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5>Share Test Results</h5>
            <button
              ref="closeShareTest"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-show="isTestLoading" class="pt-3 pb-3">
              <Spinner :isLoading="isTestLoading" />
            </div>

            <p>
              Please confirm that the test results should be shared with the employer.
            </p>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button
              :disabled="isTestLoading"
              @click="updateStatus(setForEdit.devskiller_assessment_id, 'Shared')"
              type="button"
              class="btn btn-primary btn-custom"
            >
              Share
            </button>
            <button
              type="button"
              class="btn btn-secondary btn-custom"
              data-dismiss="modal"
              ref="closeApproveModal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade bd-dislike-btn"
      tabindex="-1"
      role="dialog"
      aria-labelledby="mainModalLabel"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5>Decline</h5>

            <button
              ref="closeDeclineTest"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>
              Please confirm that no new test should be sent and no results shared with the
              employer.
            </p>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button
              @click="updateStatus(setForEdit.devskiller_assessment_id, 'Declined')"
              ref="rejectJobCancel"
              type="button"
              class="btn btn-primary"
            >
              Confirm
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              ref="closeRejectModal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- End Modals -->
  </div>
</template>

<script>
import { displayResultsBasedOnScreenHeightMixin } from '../../../mixins/displayResultsBasedOnScreenHeightMixin';
import { mapActions, mapGetters } from 'vuex';
import Pagination from '@/components/Navigations/Pagination';
import CustomMainModal from '@/components/Modals/CustomMainModal';
import AddJobBtnModal from '@/components/Admin/Jobs/AddJobBtnModal';

import Search from '../../common/Search/Search';
import { employmentMixin } from '../../../mixins/employmentMixin';
import { serviceLevelMixin } from '../../../mixins/serviceLevelMixin';
import { jobStatusMixin } from '../../../mixins/jobStatusMixin';
import { stagesMixin } from '../../../mixins/stagesMixin';
import { statusMixin } from '../../../mixins/statusMixin';
import titleMixin from '../../../mixins/titleMixin';
import ErrorList from '@/components/common/errorsList';
import axios from 'axios';

export default {
  components: {
    Pagination,
    CustomMainModal,
    AddJobBtnModal,
    Search,
    ErrorList,
  },
  mixins: [
    titleMixin,
    displayResultsBasedOnScreenHeightMixin,
    employmentMixin,
    serviceLevelMixin,
    jobStatusMixin,
    statusMixin,
    stagesMixin,
  ],
  title() {
    return 'Review Tests | Jobshark';
  },
  data: () => ({
    isTestLoading: false,
    setForEdit: {},
    totalPages: '',
    freelancers: [],
    selectedJobForApproval: {},
    selectedJobForRejection: {},
    isPreviouslySubmited: false,
    isLoading: false,
    listOfSelectedEmployers: [],
    employersSelectOptions: [],
    showModal: false,
    searchText: '',
    pageCount: 10,
    currentPage: 1,
    msgToCandidate: '',
  }),
  methods: {
    ...mapActions([
      'retrieveEmployersDropdown',
      'retrieveReviewJobs',
      'approveReviewJob',
      'rejectReviewJob',
      'retrieveFreelancerDocumentPreviewAdmin',
    ]),

    onOpenDocPreview(docId) {
      if (docId) {
        window.open(docId, '_blank');
      }
    },
    setFreelancer(freelancer) {
      this.setForEdit = freelancer;
    },
    updateStatus(id, status) {
      this.isTestLoading = true;
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/admin/review/updateassessmentstatus`,
          {
            devskiller_assessment_id: id,
            status: status,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(() => {
          this.isTestLoading = false;
          if (status === 'Sent') {
            this.$refs.closeSendTest.click();
          } else if (status === 'Shared') {
            this.$refs.closeShareTest.click();
          } else if (status === 'Declined') {
            this.$refs.closeDeclineTest.click();
          }
          this.handleSearchFilters();
        })
        .catch(err => {
          this.isTestLoading = false;
        });
    },
    onCloseAddJobModal() {
      this.showModal = false;
    },
    doSearch(searchedText) {
      this.searchText = searchedText;

      this.currentPage = 1;
      this.handleSearchFilters();
    },
    toggle() {
      this.currentPage = 1;
      this.handleSearchFilters();
    },
    getLocation(country, city) {
      if (city.name && country.name) {
        return `${city.name}, ${country.name}`;
      }
      return null;
    },
    handleSearchFilters() {
      this.isLoading = true;
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/admin/review/devskiller`,
          {
            search_word: this.searchText,
            show_all_records: this.isPreviouslySubmited,
            page: Number(this.currentPage),
            count: this.pageCount,
            employer_ids: this.listOfSelectedEmployers,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.freelancers = res.data;
          this.totalPages = res.data.last_page;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    handleSearchFiltersCurrentPage() {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/admin/freelancer/get`,
          {
            search_word: this.searchText,
            exclude_previously_reviewed: this.isPreviouslySubmited,
            page: Number(this.currentPage),
            count: this.pageCount,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.freelancers = res.data;
          this.totalPages = res.data.last_page;
          this.isLoading = false;
          this.setForEdit = {};
          this.$refs.closeApproveModal.click();
          this.$refs.closeRejectModal.click();
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    keymonitor(event) {
      // who caused it? "event.target.id"
      // console.log('keyup from id: ' + event.target.id);

      // what was pressed?
      let keyMessage = event.key || String.fromCharCode(event.keyCode);

      /* if (event.shiftKey) {
        keyMessage += 'Shift+';
      } */

      if (keyMessage == 'ArrowRight') {
        // this.nextPage();
      }

      if (keyMessage == 'ArrowLeft') {
        // this.previousPage();
      }
    },
    nextPage() {
      if (this.currentPage >= 1) {
        this.isLoading = true;
        this.currentPage++;
        this.handleSearchFilters();
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.isLoading = true;
        --this.currentPage;

        this.handleSearchFilters();
      } else {
        this.currentPage = 1;
      }
    },
    setPageByNumber(pageNumber) {
      if (pageNumber > this.totalPages || pageNumber < 1) return;
      this.isLoading = true;
      this.currentPage = pageNumber;

      this.handleSearchFilters();
    },
    setToFirstPage() {
      this.isLoading = true;
      this.currentPage = 1;

      this.handleSearchFilters();
    },
    setToLastPage(lastPage) {
      this.isLoading = true;
      this.currentPage = lastPage;

      this.handleSearchFilters();
    },
  },
  computed: {
    ...mapGetters(['getEmployersDropdown', 'getUserProfile', 'getCurrentPage', 'getTotalPages']),
  },
  mounted() {
    this.isLoading = true;
    this.handleSearchFilters();
    this.isLoading = false;
    this.retrieveEmployersDropdown();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.published {
  width: 30px;
  height: 30px;
  cursor: pointer;
  &.active {
    .svg-icon {
      fill: #f05a00;
    }
  }
}

.table-responsive {
  overflow-x: visible !important ;
}

.table-controls {
  // min-height: 50vh;
}

.modal-body {
  p {
    margin-bottom: 0;
  }
}

.fa-briefcase {
  font-size: 18px;
}

.icon-wrapper {
  .svg-icon {
    width: 18px;
    height: 18px;
  }

  /*  a {
    fill: #28a745;

    &:hover {
      fill: #1e8035;
    }
  } */

  /* a:not(:first-child) {
    fill: #f02800;

    &:hover {
      fill: #b61e00;
    }
  } */
}

.mobile-only {
  display: none;
}

.desktop-only {
  display: block;
}

.desktop-only-table {
  display: table;
  table-layout: auto;
}

.controls-wrap {
  width: 100%;
  .integration-group {
    width: 39.3%;
  }
}

.card {
  height: 81.7vh;
}

@media only screen and (max-width: 1251px) {
  .card {
    margin: 24px 23px 0 23px !important;
  }
}

@media only screen and (max-width: 992px) {
  .card {
    min-height: 100vh;
    margin: 24px 0px 0 0px !important;
  }
  .mobile-qualification {
    font-family: $font-family-sans-lato;
    display: block;
    .list-unstyled {
      li {
        a {
          text-decoration: none;
        }
        .job-ad-title {
          display: block;
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 4px;
        }
        .company-name {
          color: $color-orange;
          font-size: 15px;
          margin-bottom: 5px;
        }
        .date {
          color: #5f5f5f;
        }
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 9px 18px 15px 18px;
        .svg-icon {
          width: 22px;
          height: 22px;
          display: inline-block;
        }
        .action-buttons {
          margin-top: 8px;
          .svg-icon {
            width: 22px;
            height: 22px;
            display: inline-block;
          }
          .green {
            fill: #28a745;
          }
          .red {
            fill: #f02800;
            margin-left: 10px;
          }
        }
      }
    }
  }
  .controls-wrap {
    width: 100%;
    .integration-group {
      width: 100%;
    }
  }
  .mobile-only {
    display: block;
  }

  .desktop-only {
    display: none;
  }

  .desktop-only-table {
    display: none;
  }
}

@media only screen and (max-width: 768px) {
  .card {
    min-height: 100vh;
  }
  .mobile-qualification {
    font-family: $font-family-sans-lato;
    display: block;
    .list-unstyled {
      li {
        a {
          text-decoration: none;
        }
        .job-ad-title {
          display: block;
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 4px;
        }
        .company-name {
          color: $color-orange;
          font-size: 15px;
          margin-bottom: 5px;
        }
        .date {
          color: #5f5f5f;
        }
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 9px 18px 15px 18px;
        .svg-icon {
          width: 22px;
          height: 22px;
          display: inline-block;
        }
        .action-buttons {
          margin-top: 8px;
          .svg-icon {
            width: 22px;
            height: 22px;
            display: inline-block;
          }
          .green {
            fill: #28a745;
          }
          .red {
            fill: #f02800;
            margin-left: 10px;
          }
        }
      }
    }
  }
  .controls-wrap {
    width: 100%;
    .integration-group {
      width: 100%;
    }
  }
  .mobile-only {
    display: block;
  }

  .desktop-only {
    display: none;
  }

  .desktop-only-table {
    display: none;
  }
}

@media only screen and (max-width: 576px) {
  #wrapper {
    .card {
      min-height: 100vh !important;
      margin-top: 0 !important;
    }
  }
  .mobile-qualification {
    font-family: $font-family-sans-lato;
    display: block;
    .list-unstyled {
      li {
        a {
          text-decoration: none;
        }
        .job-ad-title {
          display: block;
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 4px;
        }
        .company-name {
          color: $color-orange;
          font-size: 15px;
          margin-bottom: 5px;
        }
        .date {
          color: #5f5f5f;
        }
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 9px 18px 15px 18px;
        .svg-icon {
          width: 22px;
          height: 22px;
          display: inline-block;
        }
        .action-buttons {
          margin-top: 8px;
          .svg-icon {
            width: 22px;
            height: 22px;
            display: inline-block;
          }
          .green {
            fill: #28a745;
          }
          .red {
            fill: #f02800;
            margin-left: 10px;
          }
        }
      }
    }
  }
  .controls-wrap {
    width: 100%;
    .integration-group {
      width: 100%;
    }
  }
  .mobile-only {
    display: block;
  }

  .desktop-only {
    display: none;
  }

  .desktop-only-table {
    display: none;
  }
}
</style>
